import { render } from "./edit.vue?vue&type=template&id=22bd71d3&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=22bd71d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22bd71d3"

export default script